// Module
var code = "<span class=\"user-template-icon\" ng-switch on=\"vm.type\"> <task-list-icon class=\"icon\" ng-switch-when=\"1\"></task-list-icon> <sms-icon ng-switch-when=\"2\"></sms-icon> <email-icon class=\"icon\" ng-switch-when=\"3\"></email-icon> <workbench-icon ng-switch-when=\"4\"></workbench-icon> </span> ";
// Exports
module.exports = code;